import {
  ReportingApiCloudRunMode,
  ReportingApiTarget,
  REPORTING_API_CLOUD_RUN_URL_DEV,
} from 'ag-common-svc/public-api';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'firebase',
  common: {
    apiKey: 'AIzaSyBQk0mf1jUDYzgdZrOoKi7TT9cINP-ttn0',
    authDomain: 'alliance-group-portal.firebaseapp.com',
    projectId: 'alliance-group-portal',
    storageBucket: 'alliance-group-portal.appspot.com',
    messagingSenderId: '271585780604',
    appId: '1:271585780604:web:bfa92dc406920565befaf9',
    measurementId: 'G-H76S2T9L7G',
  },
  google: {
    mapsAPIKey: 'AIzaSyCrFVl8PrFGe10YSFCBr9WDBtdEKb1A7LE',
    mapId: '56461284e4d20403',
  },
  domain: 'dev-arm.alliancegrouplife.com',
  agentPortalUrl: 'https://dev.alliancegrouplife.com',
  embeddedAppUrl: 'https://dev-alliance-group-embedded.firebaseapp.com',
  session_expires: 120,
  stripe_payments_public_key_live:
    'pk_live_51MON3hBZ6K5GAvsGHsgv4YoNngOOEyIFuoZ1AsXVqTNf2bUkPiThlQ7pV0DF29PnuiBstEr8btccmZnjyQAk4npA00M4BcJ3Xh',
  stripe_payments_public_key_test:
    'pk_test_51MON3hBZ6K5GAvsGVuCE875tXoedNEHv3TKS9okIkxKUDh0ML3iusdx76etQ5G5J3nMbyNQC1M28e8bSBRepNhMs00vcjKL5K2',
  user_admin_url: 'https://us-central1-alliance-group-portal.cloudfunctions.net/users',
  firebaseFunctions: {
    useFunctionsEmulator: false,
  },
  useTempMediaUpload: true,
  // Distinct from ag-portal's document — see environment.ts.
  versionSignal: {
    enabled: true,
    firestoreCollection: 'system',
    firestoreDocumentId: 'ag-crm-version',
    storageKey: 'ag_crm_web_version',
    snoozeStorageKey: 'ag_crm_web_version_snooze_until',
    fallbackPollMs: 1000 * 60,
    afterDeclinePollMs: 1000 * 60,
  },
  reportingApi: {
    target: ReportingApiTarget.CloudRun,
    cloudRun: {
      url: REPORTING_API_CLOUD_RUN_URL_DEV,
      mode: ReportingApiCloudRunMode.PreviewAuto,
      taskId: null,
    },
  },
};
